// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MyAccountFocused: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                d="M8,0 C3.58125019,0 0,3.58125019 0,8 C0,12.4187498 3.58125019,16 8,16 C12.4187498,16 16,12.4187498 16,8 C16,3.58125019 12.4187498,0 8,0 Z M8,4 C9.24281216,4 10.25,5.00749969 10.25,6.25 C10.25,7.49249983 9.24374962,8.5 8,8.5 C6.75750017,8.5 5.75,7.49249983 5.75,6.25 C5.75,5.00749969 6.7562499,4 8,4 Z M8,14 C6.34593773,14 4.84687519,13.3271875 3.7593751,12.2409372 C4.265625,10.9343748 5.515625,10 7,10 L9,10 C10.4856253,10 11.7356253,10.9337502 12.2406254,12.2409372 C11.1531248,13.328125 9.65312481,14 8,14 Z"
            />
        </svg>
    );
};

export default React.memo(MyAccountFocused);
